let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5gD5x")).then(() => parcelRequire('abzNW'));